import { Link } from "react-router-dom";
import { Bot, Landmark, LineChart, Sparkles, Trophy, Zap } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { openAI } from "@/components/ai/stream";

const TILES = [
  ["/sports", "Sports", "Games & odds", Trophy, "var(--sports)"],
  ["/predict", "Predict", "Politics, crypto & more", LineChart, "var(--cyan)"],
  ["/auto", "Bots", "Trade for you", Bot, "var(--gold)"],
  ["/accounts", "Link", "Kalshi · Polymarket · Coinbase", Landmark, "var(--sky)"],
  ["/live", "Live", "15-min & hourly", Zap, "#F97316"],
  ["ai", "Ask AI", "Any question", Sparkles, "var(--violet)"],
];

export const HomeHero = () => {
  const { profile } = useAuth();
  return (
    <section className="space-y-4 fade-up" data-testid="home-hero">
      <div>
        <div className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[.18em] text-[var(--cyan)]"><span className="live-dot" />Live now</div>
        <h1 className="font-head font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[.95] mt-2">{profile ? `What's the play, ${profile.name.split(" ")[0]}?` : "Know the odds before you play"}</h1>
        <p className="text-sm sm:text-base text-slate-400 mt-2 max-w-xl">Live odds for sports, crypto and politics. Data picks, $1,000 of practice money, and an AI that explains every market.</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5 stagger">
        {TILES.map(([to, t, d, I, c]) => {
          const body = <><span className="h-10 w-10 rounded-xl flex items-center justify-center" style={{ background: `color-mix(in srgb, ${c} 16%, transparent)`, color: c }}><I className="w-5 h-5" /></span>
            <span className="min-w-0"><span className="block font-head font-extrabold uppercase text-lg leading-none">{t}</span><span className="block text-[11px] text-slate-500 mt-1 truncate">{d}</span></span></>;
          const cls = "glass hover-lift flex items-center gap-3 p-3.5 text-left";
          return to === "ai" ? <button key={t} onClick={() => openAI({})} className={cls} data-testid="home-tile-ai">{body}</button> :
            <Link key={t} to={to} className={cls} data-testid={`home-tile-${to.replace("/", "") || "home"}`}>{body}</Link>;
        })}
      </div>
    </section>
  );
};
